import axios from 'axios';

const API = axios.create({
    baseURL: "https://api.assessoriacartoes.com.br/api/",
    // // baseURL: "http://localhost:5000/api/",
    headers: {
        "Content-Type": "application/json",
    },
});

export const createConnectToken = async (): Promise<string> => {
    try {
        const response = await API.post("Pluggy/creatConnectToken", "");
        return response.data;
    } catch (error) {
        console.error("Erro ao criar connect token:", error);
        throw error;
    }
};

export const createConnectTokenUpdate = async (id: string): Promise<string> => {
    try {
        const response = await API.post("Pluggy/creatConnectToken", id);
        return response.data;
    } catch (error) {
        console.error("Erro ao criar connect token:", error);
        throw error;
    }
};
